import { defineStore } from 'pinia'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import ThumbCell from '@/onenetwork/components/datatable/ThumbCell.vue'
import { uuid } from 'vue3-uuid'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import LinkedserviceAPI from '@/modules/linkedservice/constants/linkedservice.api.uri.const'
import { buildFilterObject } from '@/utils/filter'
import { formatTableDataLinkedService } from '../helper/table'
import { formatDataToSubmit } from '../helper/linkedservice'
import { markRaw } from 'vue'
import { SERVICE_TYPE, SERVICE_STATUS } from './../constants/linkedservice.const'

export interface tabItem {
  id: string
  label: string
  active: boolean
}

export enum LinkedServiceListActionTypes {
  FILTERING = 'FILTERING',
  PENDING = 'PENDING',
  FETCHING = 'FETCHING',
  FETCH_SUCCESS = 'FETCH_SUCCESS',
  FETCH_FAILURE = 'FETCH_FAILURE',
  CREATING = 'CREATING',
  CREATE_SUCCESS = 'CREATE_SUCCESS',
  CREATE_FAILURE = 'CREATE_FAILURE',
  DELETING = 'DELETING',
  DELETE_SUCCESS = 'DELETE_SUCCESS',
  DELETE_FAILURE = 'DELETE_FAILURE',
}

interface LinkedServiceListStore {
  action_type: LinkedServiceListActionTypes
  action_mess: string
  uuid: string
  data: Object
  filter: Array<{
    key: string
    type: string
    label: string
    placeholder: string
    value: any
    options?: Array<{ label: string; value: string }>
  }>
  pageSize: number
  page: number
  tabs: Array<any>
  tableConfig: any
  selectedIds: Array<string | number>
}

export const useLinkedServiceListStore = defineStore('linkedService.list', {
  state: (): LinkedServiceListStore => ({
    action_type: LinkedServiceListActionTypes.PENDING,
    action_mess: '',
    uuid: '',
    data: {
      list: [],
      totalRecords: 0,
      totalPage: 0,
    },
    filter: [
      {
        key: 'name',
        type: 'text',
        label: 'Tên dịch vụ',
        placeholder: 'Nhập tên dịch vụ',
        value: '',
      },
      {
        key: 'type',
        type: 'select-multiple',
        label: 'Loại dịch vụ',
        placeholder: 'Chọn loại dịch vụ',
        value: '',
        options: SERVICE_TYPE,
      },
      {
        key: 'status',
        type: 'select-multiple',
        label: 'Trạng thái',
        placeholder: 'Chọn trạng thái',
        value: '',
        options: SERVICE_STATUS,
      },
    ],
    pageSize: 10,
    page: 1,
    tabs: [
      {
        id: 'list',
        label: 'Danh sách dịch vụ liên kết',
        active: true,
      },
    ],
    tableConfig: {
      canShowHide: true,
      columns: {
        code: {
          label: 'ID',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: 'desc',
          config: {},
        },
        type: {
          label: 'Loại dịch vụ',
          component: markRaw(TagCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        status: {
          label: 'Trạng thái',
          component: markRaw(TagCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        logo: {
          label: 'Logo',
          component: markRaw(ThumbCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        name: {
          label: 'Tên dịch vụ',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        representative_name: {
          label: 'Người đại diện',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        phone: {
          label: 'SDT',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        email: {
          label: 'Email',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: false,
          config: {},
        },
        address: {
          label: 'Địa chỉ',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: '',
          config: {},
        },
        campaign: {
          label: 'Gói ngân sách',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: '',
          config: {},
        },
        expired_at: {
          label: 'Hết hạn',
          component: markRaw(DateTimeCell),
          class: '',
          visible: true,
          sort: '',
          config: {},
        },
        total_click: {
          label: 'Số lượt tiếp cận',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: '',
          config: {},
        },
        total_approach: {
          label: 'Số lượt nhấn liên hệ',
          component: markRaw(TextCell),
          class: '',
          visible: true,
          sort: '',
          config: {},
        },
      },
    },
    selectedIds: [],
  }),
  getters: {
    sortFilter: (state) => {
      const sort: any = []
      if (Object.keys(state.tableConfig?.columns).length > 0) {
        Object.keys(state.tableConfig?.columns).forEach((col) => {
          if (state.tableConfig.columns[col].sort) {
            sort.push([col, state.tableConfig.columns[col].sort])
          }
        })
      }
      return sort
    },
  },
  actions: {
    //TAB ACTION
    changeTab(targetId: string) {
      for (const tab of this.tabs) {
        tab.active = tab.id === targetId
      }
    },
    closeTab(targetId: string) {
      const index = this.tabs.findIndex((tab) => tab.id === targetId)
      if (index !== -1) {
        this.tabs.splice(index, 1)
      }
    },
    closeAllTab() {
      this.tabs = [
        {
          id: 'list',
          label: 'Danh sách dịch vụ liên kết',
          active: true,
        },
      ]
    },
    newTab(item: tabItem) {
      const exists = this.tabs.some((tab) => tab.id === item.id)
      if (!exists) {
        this.tabs.push(item)
      }
      this.changeTab(item.id)
    },

    //FILTER ACTION
    setFilter(filter: any) {
      this.filter = filter
      this.action_type = LinkedServiceListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changeFilter(key: string, value: any) {
      const filterItem = this.filter.find((item: { key: string }) => item.key === key)
      if (filterItem) {
        filterItem.value = value
        this.action_type = LinkedServiceListActionTypes.FILTERING
        this.uuid = uuid.v4()
      }
    },
    putFilter(key: string, value: any) {
      this.filter = this.filter.map((field) => {
        if (field.key === key) {
          return { ...field, value: value }
        }
        return field
      })
    },

    //PAGE ACTION
    changePage(page: number) {
      this.page = page
      this.action_type = LinkedServiceListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changePageSize(size: number) {
      this.pageSize = size
      this.action_type = LinkedServiceListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //TABLE CONFIG ACTION
    toggleColumnVisibility(columnCode: string, visible: boolean) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].visible = visible
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    toggleSort(columnCode: string, sort: string) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].sort = sort
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },

    //DATA ACTION
    async fetchList() {
      return new Promise(async (resolve, reject) => {
        try {
          this.action_type = LinkedServiceListActionTypes.FETCHING
          const sort = this.sortFilter
          const pagination = {
            page: this.page,
            pageSize: this.pageSize,
            sort,
            order_by: 'id',
            order_dir: 'desc',
          }
          const res = await APIClient.get(LinkedserviceAPI.list, {
            params: buildFilterObject(this.filter, pagination),
          })
          const { data } = res.data;
          this.data = {
            list: formatTableDataLinkedService(data.data || []),
            totalRecords: data.total ?? 0,
            totalPage: data.last_page ?? 0,
          }
          this.action_type = LinkedServiceListActionTypes.FETCH_SUCCESS
          resolve(res)
        } catch (e) {
          this.action_type = LinkedServiceListActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    },
    async createLinkedService(values: any) {
      return new Promise(async (resolve, reject) => {
        try {
          this.action_type = LinkedServiceListActionTypes.CREATING
          const data = formatDataToSubmit(values)
          const res = await APIClient.post(LinkedserviceAPI.create, data)
          this.action_type = LinkedServiceListActionTypes.CREATE_SUCCESS
          resolve(res.data.data)
        } catch (e) {
          console.error('Error creating listing:', e)
          this.action_type = LinkedServiceListActionTypes.CREATE_FAILURE
          reject(e?.response?.data)
        }
      })
    },
    async deleteListing(listing_ids: string) {
      return new Promise(async (resolve, reject) => {
        try {
          this.action_type = LinkedServiceListActionTypes.DELETING
          const res = await APIClient.delete(LinkedserviceAPI.delete, {
            data: { listing_ids },
          })
          this.action_type = LinkedServiceListActionTypes.DELETE_SUCCESS
          resolve(true)
        } catch (e) {
          console.error('Error deleting listing:', e)
          this.action_type = LinkedServiceListActionTypes.DELETE_FAILURE
          reject(e?.response?.data)
        }
      })
    },
  },
})
